import './MessageEditor.css';
import React, { useState } from 'react';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { supabase } from '../../../supabaseClient';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const MessageEditor = ({companyId}) => {
  const [title, setTitle] = useState('');
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleGetHtml = () => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const html = draftToHtml(rawContentState);
    return html;
  };

  const handleSaveMessage = async () => {
    try {
      const { data, error } = await supabase
        .from('messages')
        .insert([{ title, content: handleGetHtml(), company: companyId }]);

      if (error) {
        throw error;
      }

      console.log('Message saved successfully');
      setEditorState(EditorState.createEmpty());
      setTitle(''); // Restablecer el estado del título
    } catch (error) {
      console.error('Error saving message:', error.message);
    }
  };

  const toolbarOptions = {
    options: ['inline', 'blockType', 'list', 'textAlign'],
    inline: {
      options: ['bold', 'italic', 'underline'],
    },
  };

  return (
    <>
      <TextField
        label="Título"
        value={title}
        onChange={handleTitleChange}
        fullWidth
        margin="normal"
      />

      <Editor
        editorState={editorState}
        onEditorStateChange={(editorState) => setEditorState(editorState)}
        editorClassName="message-editor"
        toolbar={toolbarOptions}
        placeholder={'Mensaje'}
        spellCheck={true}
        emoji={true}
      />

      <Button variant="contained" onClick={handleSaveMessage}>
        Publicar
      </Button>
      </>
  );
};

export default MessageEditor;
